import { render, staticRenderFns } from "./RefundCard.vue?vue&type=template&id=2fc9a98c&scoped=true&"
import script from "./RefundCard.vue?vue&type=script&lang=js&"
export * from "./RefundCard.vue?vue&type=script&lang=js&"
import style0 from "./RefundCard.vue?vue&type=style&index=0&id=2fc9a98c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9a98c",
  null
  
)

export default component.exports